import { TAO_KOE, TaoConsole, Cookies } from '../libs';

const Tracking = {};

const readUTMParams = function() {
	const params = new URLSearchParams( window.location.search );

	const utmParams = [
		'UTM_SOURCE',
		'UTM_MEDIUM',
		'UTM_CAMPAIGN',
		'UTM_TERM',
		'UTM_CONTENT',
	];

	for ( const [ key, value ] of params.entries() ) {
		if ( utmParams.includes( key.toUpperCase() ) && value ) {
			Cookies.set( key, value );
		}
	}
};

Tracking.init = function( $ ) {
	$( window ).on( 'load_marketing_scripts.en', function() {
		readUTMParams();
	} );

	$( document ).ready( function() {
		const promotions = window.TaoDataLayer || [];
		window.dataLayer = window.dataLayer || [];

		if ( promotions && promotions.length > 0 ) {
			window.dataLayer.push( {
				'event': 'promotionView',
				'ecommerce': {
					'promoView': {
						promotions,
					},
				},
			} );
		}
	} );

	$( document ).on( 'click', '.promo_tracking', function() {
		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push( {
			'event': 'promotionClick',
			'ecommerce': {
				'promoClick': {
					'promotions': [ {
						'id': $( this ).data( 'gtmid' ),
						'name': $( this ).data( 'gtmname' ) || $( this ).data( 'gtmid' ),
					} ],
				},
			},
		} );
	} );

	const trackVideos = () => {
		const videos = document.querySelectorAll( 'video' );

		videos.forEach( ( video ) => {
			// Set flags for each video.
			let fullSeen = false;
			let halfSeen = false;

			// Add event listener for time tracking.
			video.addEventListener( 'timeupdate', () => {
				const currTime = Math.floor( video.currentTime );
				const fullLength = Math.floor( video.duration );
				const treshold = fullLength / 2;

				if ( currTime >= treshold && ! halfSeen ) {
					TaoConsole.log( '50% erreicht!' );
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push( {
						event: 'gtmVideoPlay',
					} );

					halfSeen = true;
				} else if ( currTime === fullLength && ! fullSeen ) {
					TaoConsole.log( '100% erreicht!' );
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push( {
						event: 'gtmVideoEngage',
						gtmVideoPlayheadPosition: '50',
					} );

					fullSeen = true;
				}
			} );
		} );
	};

	trackVideos();
};

Tracking.sendIdentifyEvent = ( spec, email, event ) => {
	const DYO = window.DYO;
	const dataLayer = window.dataLayer = window.dataLayer || [];
	const updatedMail = email !== null && email !== undefined ? DYO.dyhash.sha256( email.toLowerCase() ) : 'undefined';
	let updatedEvent;

	switch ( event ) {
		case 'Friend Invite':
		case 'Geschenkkarte':
		case 'Pluscard':
			updatedEvent = event;
			break;
		default:
			updatedEvent = spec + ' ' + event;
	}

	dataLayer.push( {
		event: 'gtmIdentification ' + spec,
		gtmEmailSHA256: updatedMail,
		gtmIdentifySpec: spec,
		gtmEventString: updatedEvent,
	} );
};

Tracking.saveSiteHash = () => {
	const hash = window.location.hash;
	const siteHash = hash.substring( 1, hash.length );
	sessionStorage.setItem( 'sitehash', siteHash );
};

// Init.
TAO_KOE.ready( 'tracking.js', Tracking.init );

// Expose.
TAO_KOE.Tracking = Tracking;
export default Tracking;
